// getters
const getters = {
    appinfo: state => state.appinfo.data,
    mapv2info: state => state.mapv2.data
}

export default getters
